import ConnectorRegistry from "../components/connectors/controllers/ConnectorRegistry";
import AmazonConnectConnector, {
  amazonConnectSchema,
} from "../components/connectors/models/AmazonConnector";
import CXoneConnector, {
  cxOneSchema,
} from "../components/connectors/models/CXOneConnector";
import Five9Connector, {
  five9Schema,
} from "../components/connectors/models/Five9Connector";

export const registerConnectors = () => {
  const registry = ConnectorRegistry.getInstance();

  registry.registerConnector(
    CXoneConnector.Type,
    new CXoneConnector(),
    cxOneSchema
  );
  registry.registerConnector(
    Five9Connector.Type,
    new Five9Connector(),
    five9Schema
  );
  registry.registerConnector(
    AmazonConnectConnector.Type,
    new AmazonConnectConnector(),
    amazonConnectSchema
  );
};
